module.exports = __webpack_public_path__ + "img/naozhong.24dbd914.png";